module.exports = __webpack_public_path__ + "static/media/badge.938e98bb.svg";